/* 鶏雫 — 電話タップ・地図タップの計測。
   theme.liquid で GA4 の計測 ID が入っているときだけ読み込まれる。
   gtag が無いときは何もしない（読み込み順で先に click された場合も安全）。 */
(function () {
  function send(name, label) {
    if (typeof window.gtag !== 'function') return;

    // GA4 のイベント（コンバージョンラベルの有無にかかわらず送る）
    window.gtag('event', name);

    // Google 広告のコンバージョン（ラベルが入っているときだけ）
    if (label) window.gtag('event', 'conversion', { send_to: label });
  }

  function isMapLink(href) {
    return href.indexOf('maps.app.goo.gl') !== -1 ||
           href.indexOf('google.com/maps') !== -1 ||
           href.indexOf('maps.google.com') !== -1;
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';

    if (href.indexOf('tel:') === 0) {
      send('phone_call_click', window.tsAdsTelLabel);
      return;
    }
    if (isMapLink(href)) {
      send('map_route_click', window.tsAdsMapLabel);
    }
  }, true);
})();
